exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IIwijnjvLpVIoGy12JN8l{position:absolute}.itemSelected{display:block}", ""]);

// exports
exports.locals = {
	"gridItem": "IIwijnjvLpVIoGy12JN8l"
};